/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Complete_TitleInputs */

const en_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch export complete`)
};

const fr_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lots terminée`)
};

const de_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelexport abgeschlossen`)
};

const it_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione batch completata`)
};

const ru_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт партии завершен.`)
};

const es_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación por lotes completada`)
};

const zh_cn2_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出完成`)
};

const ja_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポート完了`)
};

const hi_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात पूर्ण`)
};

const pt_pt2_explorer_info_batch_complete_title = /** @type {(inputs: Explorer_Info_Batch_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote concluída`)
};

/**
* | output |
* | --- |
* | "Batch export complete" |
*
* @param {Explorer_Info_Batch_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_complete_title = /** @type {((inputs?: Explorer_Info_Batch_Complete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Complete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_complete_title(inputs)
	if (locale === "de") return de_explorer_info_batch_complete_title(inputs)
	if (locale === "it") return it_explorer_info_batch_complete_title(inputs)
	if (locale === "ru") return ru_explorer_info_batch_complete_title(inputs)
	if (locale === "es") return es_explorer_info_batch_complete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_complete_title(inputs)
	if (locale === "ja") return ja_explorer_info_batch_complete_title(inputs)
	if (locale === "hi") return hi_explorer_info_batch_complete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_complete_title(inputs)
	return en_explorer_info_batch_complete_title(inputs)
});